import Vue from 'vue'

// 通用日期格式化：根据 VUE_APP_Theme 选择不同的日期顺序
// vnzb-theme 使用 dd-mm-yyyy hh:mm；其他主题使用 yyyy-mm-dd hh:mm
const formatDateTime = function (val) {
  const pad = (n) => (n >= 10 ? n : '0' + n)
  const d = new Date(val)
  const y = d.getFullYear()
  const m = pad(d.getMonth() + 1)
  const day = pad(d.getDate())
  const h = pad(d.getHours())
  const mm = pad(d.getMinutes())
  return process.env.VUE_APP_Theme !== 'vnzb-theme'
    ? `${y}-${m}-${day} ${h}:${mm}`
    : `${day}-${m}-${y} ${h}:${mm}`
}

// 过滤器：保留原始 falsy 返回 undefined 的语义
Vue.filter('normalTime', function (val) {
  if (val) return formatDateTime(val)
})

// 把时间戳转换成本地时间
export const transformToBeijingTime = formatDateTime

Vue.filter("calcHeatDegree", function (num) {
  num = parseFloat(num);
  if (Number.isNaN(num)) return "";
  if (process.env.VUE_APP_Theme == 'vnzb-theme') {
    if (num < 1000) return num;
    else if (num < 10000000) {
      num = num / 100;
      num = Math.round(num);
      return (num % 10 == 0 ? num / 10 + ".0" : num / 10) + "K";
    } else {
      num = num / 100000;
      num = Math.round(num);
      return (num % 10 == 0 ? num / 10 + ".0" : num / 10) + "M";
    }
  } else {
    if (num < 10000) return num;
    else if (num < 100000000) {
      num = num / 1000;
      num = Math.round(num);
      return (num % 10 == 0 ? num / 10 + ".0" : num / 10) + "万";
    } else {
      num = num / 10000000;
      num = Math.round(num);
      return (num % 10 == 0 ? num / 10 + ".0" : num / 10) + "亿";
    }
  }
});

export const debounce = function (fn, delay) {
  var timer = null;
  // 保持与原版兼容：参数未传或为 0 时统一走 300ms
  delay = delay || 300;
  return function () {
    var args = arguments;
    var that = this;
    // 清除上一次延时器
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(that, args)
    }, delay);
  }
}